module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fdzna"))).then(() => parcelRequire('cvs7o'));